import { combineReducers } from '@reduxjs/toolkit';
import { AppThunkApi, AppThunkApiConfig, PdpDispatch, PdpState, PdpStore, PdpThunk } from '@ff-os/pdp-shared-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { reducer as generalUi } from './slices/generalUiSlice';
import { reducer as groups } from './slices/groupsSlice';
import { reducer as groupsUi } from './slices/groupsUiSlice';
import { reducer as photos } from './slices/photosSlice';
import { reducer as quality } from './slices/qualitySlice';
import { reducer as version } from './slices/versionSlice';

const projectReducers = {
    version,
    groups,
    photos,
    quality
};

const uiReducers = {
    general: generalUi,
    groups: groupsUi
};

export const photoPrintsPluginReducers = {
    ui: combineReducers(uiReducers),
    project: combineReducers(projectReducers)
};

export type PhotoPrintsPdpStore = PdpStore<PhotoPrintsJson.Project>;
export type PhotoPrintsPdpDispatch = PdpDispatch<PhotoPrintsJson.Project>;
export type PhotoPrintsPdpState = PdpState<PhotoPrintsJson.Project>;
export type PhotoPrintsPdpThunk<ReturnType = void> = PdpThunk<PhotoPrintsJson.Project, ReturnType>;
export type PhotoPrintsThunkApi = AppThunkApi<PhotoPrintsJson.Project>;
export type PhotoPrintsThunkApiConfig = AppThunkApiConfig<PhotoPrintsJson.Project>;